export default {
	'technical-and-financial-offers': 'Ofertas técnicas y económicas',
    'the-technical-and-financial-offers': 'la oferta técnica y económica?',
    'technical-and-financial-offer': 'Oferta técnicas y económicas',
    'add-a-technical-and-financial-offer': 'añadir una oferta técnica y económica'
}